<template>
  <a-modal
    v-model:visible="visible"
    :title="props.modaltitle ? props.modaltitle : '回退流程'"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="df both-side">
      <a-textarea
        style="width: 400px"
        :placeholder="props.modaltitle ? '请输入反馈意见' : '请输入回退原因'"
        v-model:value="inputVal"
        auto-size
      ></a-textarea>
    </div>
  </a-modal>
</template>

<script>
import { Toast } from "@/utils";
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    modaltitle: String,
  },
  setup(props, context) {
    const visible = ref(false);
    const inputVal = ref(null);
    const handleOk = () => {
      if (!inputVal.value) {
        const toastText = props.modaltitle ? '请输入反馈意见' : '请输入回退原因';
        Toast("warning", toastText, 3);
        return;
      }
      context.emit("rollBack", inputVal.value);
    };

    const showModal = () => {
      visible.value = true;
    };

    const setInputData = (val) => {
      inputVal.value = val;
    };

    const handleCancel = () => {
      inputVal.value = null;
      visible.value = false;
    };
    return {
      props,
      visible,
      inputVal,
      handleOk,
      handleCancel,
      showModal,
      setInputData,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
